// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__15Ypx","author":"Table_author__2h961","authorImage":"Table_authorImage__1eKX7","unreadRow":"Table_unreadRow__18SgW"};